var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-min-space"},[_c('b-form-group',{class:{
            'required-field': _vm.field.isRequired,
        },attrs:{"label-for":`id_${_vm.field._id}`}},[_c('label',{class:{
                'urdu-label': _vm.urduLabel,
            }},[_vm._v(_vm._s(_vm.field.label))]),_c('div',{staticClass:"row profile-setup remove-form-group"},[_c('div',{staticClass:"col-md-5 mb-20 dialling-code-field"},[_c('isd-code',{directives:[{name:"validate",rawName:"v-validate",value:({
                        required: true,
                    }),expression:"{\n                        required: true,\n                    }"}],class:{
                        'is-invalid': _vm.errors.has('Dialing Code'),
                    },attrs:{"data-segment-id":_vm.dataSegmentId,"field":{
                        association: 'countries',
                        type: 'isd-code',
                        isLocked: true,
                        isRequired: _vm.field.isRequired,
                        label: 'Dialing code',
                        placeholder: 'Dialing code',
                        isDisabled: _vm.field.isDisabled,
                        options: [],
                        key: _vm.selectKey()
                    },"text-field":"isdCodeTitle","value-field":"_id","multiple":false,"name":"Dialing Code"}})],1),_c('div',{staticClass:"col-md-7"},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({
                        required: _vm.field.isRequired,
                        max: 10,
                        min: 10,
                        regex: /^[1-9][0-9]{9}$/,
                    }),expression:"{\n                        required: field.isRequired,\n                        max: 10,\n                        min: 10,\n                        regex: /^[1-9][0-9]{9}$/,\n                    }"}],class:{
                        'is-invalid': _vm.errors.has('phone number'),
                    },attrs:{"type":"tel","maxLength":"10","disabled":_vm.loading || _vm.field.isDisabled,"placeholder":"Enter phone number (300XXXXXXX)","data-vv-name":"phone number"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }